declare let window: any 
export const isReactNative = window && window.navigator != 'undefined' && window.navigator.product == 'ReactNative'